import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import { apiIntent } from "../consts/links";
export const getIntent = async (params, signal) => {
    return await baseFetch({
        url: getUrlWithSearchParams(apiIntent, {}),
        withCredentials: true,
        params,
        signal,
    });
};
